export const TAGS_UI = {
  clearFiltersLabel: "Clear Filters",
};
